import { AppModules } from 'appContainer/types';
import { filterParam } from 'router/declarative/filterParam';
import {
  booleanParam,
  sortingParam,
  stringParam,
} from 'router/declarative/paramRegistry';
import { AccessControlTabs } from '../navigation/types';
import { PathRouteContent, RouteNode } from 'router/declarative/routeNode';
import { accessControlRoutes } from './consts';

export const routes = {
  path: accessControlRoutes.root,
  title: 'Access control',
  appModule: AppModules.ACCESS_CONTROL_V2,
  content: async (): PathRouteContent =>
    (await import('./AccessControlLayout')).AccessControlLayout,
  children: [
    {
      path: `/${AccessControlTabs.SERVICE_ACCOUNTS}`,
      content: async () =>
        (await import('../pages/serviceAccounts/ServiceAccountsRoutePage'))
          .ServiceAccountsRoutePage,
    },
    {
      path: `/${AccessControlTabs.MEMBERS}`,
      searchParams: {
        filter: filterParam,
        sorting: sortingParam,
        query: stringParam,
        invite: booleanParam,
      },
      content: async () =>
        (await import('../components/EmptyShell')).EmptyShell,
      children: [
        {
          path: { layout: true },
          content: async () =>
            (await import('../pages/orgMembers/UsersRoutePage')).UsersRoutePage,
          children: [{ path: { index: true } }],
        },
        {
          path: '/:userId',
          content: async () =>
            (await import('../pages/UserProfile/UserProfileRoutePage'))
              .UserProfileRoutePage,
          children: [
            { path: { index: true } },
            { path: '/roles' },
            { path: '/groups' },
            { path: '/assets' },
          ],
        },
      ],
    },
    {
      path: `/${AccessControlTabs.PERMISSION_GROUPS}`,
      content: async () =>
        (await import('../components/EmptyShell')).EmptyShell,
      children: [
        {
          path: { index: true },
          content: async () =>
            (
              await import('../pages/PermissionGroups/PermissionGroupsRoutePage')
            ).PermissionGroupsRoutePage,
        },
        {
          path: '/:groupId',
          content: async () =>
            (
              await import('../pages/PermissionGroups/PermissionGroupsDetailsRoutePage')
            ).PermissionGroupsDetailsRoutePage,
        },
      ],
    },
    {
      path: `/${AccessControlTabs.MANAGE_USER_ROLES}`,
      content: async () =>
        (await import('../pages/ManageUserRoles/ManageUserRolesRoutePage'))
          .ManageUserRolesRoutePage,
    },
    {
      path: `/${AccessControlTabs.ASSETS_OVERVIEW}`,
      content: async () =>
        (await import('../pages/AssetsOverview/AssetsOverviewPageRoute'))
          .AssetsOverviewRoutePage,
    },
    {
      path: `/${AccessControlTabs.IP_ALLOWLIST_MANAGEMENT}`,
      content: async () =>
        (await import('../pages/IPAllowListing/IPAllowListingPageRoute'))
          .IPAllowListingRoutePage,
    },
    {
      path: `/${AccessControlTabs.CONFIDENTIAL_FIELDS}`,
      content: async () =>
        (
          await import('../pages/ConfidentialFields/ConfidentialFieldsRoutePage')
        ).ConfidentialFieldsRoutePage,
    },
    {
      path: `/${AccessControlTabs.LOGIN_SETTINGS}`,
      content: async () =>
        (await import('../pages/loginSettings/LoginSettingsRoutePage'))
          .LoginSettingsRoutePage,
    },
    {
      path: `/${AccessControlTabs.SCIM_TOKEN}`,
      content: async () =>
        (await import('../pages/SCIMManagement/SCIMTokenRoutePage'))
          .SCIMTokenRoutePage,
    },
    {
      path: `/${AccessControlTabs.SSO_ATTRIBUTE_MAPPING}`,
      searchParams: { filter: filterParam },
      content: async (): PathRouteContent =>
        (
          await import('../pages/ssoAttributeMapping/SSOAttributeMappingRoutePage')
        ).SSOAttributeMappingRoutePage,
    },
  ],
} as const satisfies RouteNode;
